



























import { RankingActionEnum } from '@empathybroker/tsclient-play/dist/enums/ranking-action.enum';

import { ColorEnum } from '../../enums';

import EpbBadge from '../badge.component.vue';
import EpbButton from '../button.component.vue';

export default {
  name: 'ranking-result-overlay',
  components: {
    EpbButton,
    EpbBadge
  },
  props: {
    result: {
      type: Object,
      required: true
    },
    hovered: Boolean
  },
  data: function () {
    return {
      RankingActionEnum,
      ColorEnum
    };
  },
  methods: {
    onActionClick: function (result, action: RankingActionEnum): void {
      if (action === result.status) {
        action = undefined;
      }
      this.$emit('statusChange', action);
    },
    getActionText: function (result, action: RankingActionEnum): string {
      const actionMessages = this.$epb.messages.tools.configurations.fields.products.actions;
      return {
        [RankingActionEnum.BOOST]: () => (result.status === RankingActionEnum.BOOST) ? actionMessages.unboost
          : actionMessages.boost,
        [RankingActionEnum.BURY]: () => (result.status === RankingActionEnum.BURY) ? actionMessages.unbury
          : actionMessages.bury
      }[action]();
    },
    getActionColor(action: RankingActionEnum): ColorEnum {
      return {
        [RankingActionEnum.BOOST]: () => ColorEnum.GREEN,
        [RankingActionEnum.BURY]: () => ColorEnum.RED
      }[action]();
    }
  }
};
